/* eslint no-shadow: ["error", { "allow": ["state", "getters"] }] */

import findIndex from 'lodash/findIndex'
import keyBy from 'lodash/keyBy'
import reject from 'lodash/reject'
import Vue from 'vue'

import { FETCH_BRANDS } from '../../actions.type'
import {
  CREATE_BRAND,
  REMOVE_BRAND,
  SET_BRAND_ALL_REQUEST,
  SET_BRAND_ALL_VALUE,
  UPDATE_BRAND
} from '../../mutations.type'

const state = {
  all: {
    request: {
      isLoading: undefined,
      isSuccess: undefined,
      isError: undefined,
      isFatalError: undefined,
      delay: undefined,
      lastRequestTime: undefined
    },
    value: []
  }
}

const getters = {
  brandAllValue: (state) => state.all.value,
  brandAllRequest: (state) => state.all.request,
  brandAllById: (state) => keyBy(state.all.value, 'id')
}

const actions = {
  async [FETCH_BRANDS]({ commit, state }, params) {
    if (
      (state.all.request.isSuccess && !params?.isReload) ||
      state.all.request.isLoading ||
      state.all.request.isError
    ) {
      return
    }
    try {
      const { data } = await Vue.axios.get('brand', {
        'axios-retry': {
          beforeTry: () => {
            commit(SET_BRAND_ALL_REQUEST, {
              isLoading: true,
              isError: false
            })
          },
          afterTry: ({ delay, lastRequestTime }) => {
            commit(SET_BRAND_ALL_REQUEST, {
              isLoading: false,
              isError: true,
              delay,
              lastRequestTime
            })
          }
        }
      })
      commit(SET_BRAND_ALL_REQUEST, {
        isLoading: false,
        isSuccess: true
      })
      commit(SET_BRAND_ALL_VALUE, data)
    } catch (e) {
      commit(SET_BRAND_ALL_REQUEST, {
        isFatalError: true,
        isLoading: false
      })
    }
  },

  async SOCKET_CREATE_BRAND({ commit }, value) {
    commit(CREATE_BRAND, value)
  },

  async SOCKET_UPDATE_BRAND({ commit }, value) {
    commit(UPDATE_BRAND, value)
  },

  async SOCKET_REMOVE_BRAND({ commit }, id) {
    commit(REMOVE_BRAND, id)
  }
}

const mutations = {
  [SET_BRAND_ALL_REQUEST](state, request) {
    state.all.request = {
      ...state.all.request,
      ...request
    }
  },
  [SET_BRAND_ALL_VALUE](state, brands) {
    state.all.value = brands
  },
  [UPDATE_BRAND](state, updatedBrand) {
    state.all.value.splice(
      findIndex(state.all.value, { id: updatedBrand.id }),
      1,
      updatedBrand
    )
  },
  [CREATE_BRAND](state, createdBrand) {
    state.all.value.push(createdBrand)
  },
  [REMOVE_BRAND](state, id) {
    state.all.value = reject(state.all.value, { id })
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
